module.exports = __webpack_public_path__ + "static/media/Team_06.55088e33.png";